import { render, staticRenderFns } from "./EmergencyTransportPatientRegister.vue?vue&type=template&id=2e6e4534&scoped=true&lang=pug"
import script from "./EmergencyTransportPatientRegister.vue?vue&type=script&lang=ts"
export * from "./EmergencyTransportPatientRegister.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyTransportPatientRegister.vue?vue&type=style&index=0&id=2e6e4534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e4534",
  null
  
)

export default component.exports